export const log = {
  logDetail: "日志详情",
  operationType: "操作类型",
  operationObject: "操作对象",
  objectName: "对象名称",
  operationUser: "账号",
  add: "新建",
  edit: "编辑",
  delete: "删除",
  bind: "绑定",
  unbind: "解绑",
  login: "{0}登入{1}",
  logout: "{0}登出{1}",
  fleet: "车间",
  vehicle: "设备",
  model: "车型",
  driver: "司机",
  account: "账号",
  role: "角色",
  repair: "维修",
  maintenance: "保养",
  device: "系统设置",
  remind: "提醒设置",
  inspectionTemplate: "点检模板",
  maintenanceTemplate: "保养模板",
  inspectionItem: "点检模板项目",
  inspectionGroup: "点检模板分组",
  inspection: "点检报告",
  geofence: "电子围栏",
  remindSetting: "提醒设置",
  logNumber: "序号",
  logDate: "时间",
  mobile: "手机号",
  name: "姓名",
  visitIP: "访问IP",
  detail: "详情",
  addDetail: "新建{0} “{1}”",
  deleteDetail: "删除{0} “{1}”",
  editDetail: "编辑{0} “{1}”",
  changeItemAdd: "新增",
  changeItemDelete: "删除",
  passwordChange: "密码变更",
  fleetColor: "车间颜色",
  itemName: "项目名",
  groupName: "分组名",
  admin: "管理员",
  web: "Web端",
  weChat: "微信小程序端",
  feishu: "飞书端",
};
